<div class="d-flex flex-column flex-lg-row">
	<div class="flex-column flex-lg-row-auto w-100 w-lg-200px w-xl-300px mb-10">
		<div class="card card-flush">
			<div class="card-header">
				<div class="card-title">
					<h2 class="mb-0">{{ roleData?.name || 'Loading...' }}</h2>
				</div>
			</div>
			<div class="card-body pt-0">
				<!-- <div #jstreeContainer id="kt_permissions_jstree_checkable d-none"></div> -->
				<!-- Dynamic permissions display -->
				<div class="d-flex flex-column text-gray-600" *ngIf="roleData?.permissions">
					<div class="d-flex align-items-center py-2" *ngFor="let description of getPermissionDescription(roleData.permissions)">
						<span class="bullet bg-primary me-3"></span>
						{{ description }}
					</div>
				</div>
				<!-- Loading state -->
				<div class="d-flex flex-column text-gray-600" *ngIf="!roleData">
					<div class="d-flex align-items-center py-2">
						<span class="bullet bg-secondary me-3"></span>
						Loading role permissions...
					</div>
				</div>
				<!-- Commented out hardcoded directory structure description -->
				<!--
				<div class="d-flex flex-column text-gray-600">
					<div class="d-flex align-items-center py-2">
						<span class="bullet bg-primary me-3"></span>
						Some Admin Controls
					</div>
					<div class="d-flex align-items-center py-2">
						<span class="bullet bg-primary me-3"></span>
						View Financial Summaries only
					</div>
					<div class="d-flex align-items-center py-2">
						<span class="bullet bg-primary me-3"></span>
						View and Edit API Controls
					</div>
					<div class="d-flex align-items-center py-2">
						<span class="bullet bg-primary me-3"></span>
						View Payouts only
					</div>
					<div class="d-flex align-items-center py-2">
						<span class="bullet bg-primary me-3"></span>
						View and Edit Disputes
					</div>
					<div class="d-flex align-items-center py-2 d-none">
						<span class="bullet bg-primary me-3"></span>
						<em>and 3 more...</em>
					</div>
				</div>
				-->
			</div>
			<div class="card-footer pt-0">
				<button type="button" class="btn btn-light btn-active-primary" (click)="editRole()">
					Edit Role
				</button>
			</div>
		</div>
	</div>
	<div class="flex-lg-row-fluid ms-lg-10">
		<div class="card card-flush mb-6 mb-xl-9">
			<div class="card-header pt-5">
				<div class="card-title">
					<h2 class="d-flex align-items-center">
						Agents Assigned
						<span class="text-gray-600 fs-6 ms-1">({{roleData.users_count}})</span>
					</h2>
				</div>
				<div class="card-toolbar">
					<div class="d-flex align-items-center position-relative my-1" data-table-toolbar="base">
						<i class="ki-duotone ki-magnifier fs-1 position-absolute ms-6">
							<span class="path1"></span>
							<span class="path2"></span>
						</i>
						<input type="text" data-table-filter="search" class="form-control form-control-sm w-250px ps-15" placeholder="Search" />
					</div>
					<div class="d-flex justify-content-end align-items-center d-none" data-table-toolbar="selected">
						<div class="fw-bold me-5">
							<span class="me-2" data-table-select="selected_count"></span>
							Selected
						</div>
						<button type="button" class="btn btn-sm btn-dark" data-table-select="delete_selected">
							Delete Selected
						</button>
					</div>
				</div>
			</div>
			<div class="card-body pt-0">
				<table class="table align-middle table-bordered fs-6 rounded-3 overflow-hidden" id="kt_table_role_view">
					<thead>
						<tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0 bg-primary-subtle">
							<th class="w-10px pe-2">
								<div class="form-check form-check-sm form-check-custom form-check-solid me-3">
									<input class="form-check-input" type="checkbox" data-check="true" data-check-target="#kt_table_role_view .form-check-input" value="1" />
								</div>
							</th>
							<th class="min-w-50px">ID</th>
							<th class="min-w-150px">User</th>
							<th class="min-w-125px">Joined Date</th>
							<th class="text-end min-w-100px">Actions</th>
						</tr>
					</thead>
					<tbody class="fw-semibold text-gray-600">
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID5435</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label">
											<img src="assets/media/avatars/300-6.jpg" alt="Emma Smith" class="w-100" />
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Emma Smith</a>
									<span>smith@email.com</span>
								</div>
							</td>
							<td>05 May 2024, 10:30 am</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID9206</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label fs-3 bg-light-danger text-danger">
											M
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Melody Macy</a>
									<span>melody@altbox.com</span>
								</div>
							</td>
							<td>10 Mar 2024, 6:05 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID9019</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label">
											<img src="assets/media/avatars/300-1.jpg" alt="Max Smith" class="w-100" />
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Max Smith</a>
									<span>max@kt.com</span>
								</div>
							</td>
							<td>21 Feb 2024, 11:30 am</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID5345</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label">
											<img src="assets/media/avatars/300-5.jpg" alt="Sean Bean" class="w-100" />
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Sean Bean</a>
									<span>sean@dellito.com</span>
								</div>
							</td>
							<td>20 Jun 2024, 10:10 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID1837</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label">
											<img src="assets/media/avatars/300-25.jpg" alt="Brian Cox" class="w-100" />
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Brian Cox</a>
									<span>brian@exchange.com</span>
								</div>
							</td>
							<td>20 Dec 2024, 11:30 am</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID3297</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label fs-3 bg-light-warning text-warning">
											C
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Mikaela Collins</a>
									<span>mik@pex.com</span>
								</div>
							</td>
							<td>24 Jun 2024, 6:05 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID8651</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label">
											<img src="assets/media/avatars/300-9.jpg" alt="Francis Mitcham" class="w-100" />
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Francis Mitcham</a>
									<span>f.mit@email.com</span>
								</div>
							</td>
							<td>10 Nov 2024, 8:43 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID8580</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label fs-3 bg-light-danger text-danger">
											O
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Olivia Wild</a>
									<span>olivia@corpmail.com</span>
								</div>
							</td>
							<td>25 Jul 2024, 10:30 am</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID7174</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label fs-3 bg-light-primary text-primary">
											N
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Neil Owen</a>
									<span>owen.neil@gmail.com</span>
								</div>
							</td>
							<td>19 Aug 2024, 6:05 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID1771</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label">
											<img src="assets/media/avatars/300-23.jpg" alt="Dan Wilson" class="w-100" />
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Dan Wilson</a>
									<span>dam@consilting.com</span>
								</div>
							</td>
							<td>22 Sep 2024, 6:05 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID4624</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label fs-3 bg-light-danger text-danger">
											E
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Emma Bold</a>
									<span>emma@intenso.com</span>
								</div>
							</td>
							<td>22 Sep 2024, 6:05 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID9786</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label">
											<img src="assets/media/avatars/300-12.jpg" alt="Ana Crown" class="w-100" />
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Ana Crown</a>
									<span>ana.cf@limtel.com</span>
								</div>
							</td>
							<td>10 Nov 2024, 2:40 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID9112</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label fs-3 bg-light-info text-info">
											A
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">Robert Doe</a>
									<span>robert@benko.com</span>
								</div>
							</td>
							<td>20 Dec 2024, 6:05 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
						<tr>
							<td>
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" value="1" />
								</div>
							</td>
							<td>ID4078</td>
							<td class="d-flex align-items-center">
								<div class="symbol symbol-circle symbol-50px overflow-hidden me-3">
									<a [routerLink]="['/common','admin-users','user-detail']">
										<div class="symbol-label">
											<img src="assets/media/avatars/300-13.jpg" alt="John Miller" class="w-100" />
										</div>
									</a>
								</div>
								<div class="d-flex flex-column">
									<a [routerLink]="['/common','admin-users','user-detail']" class="text-gray-800 text-hover-primary mb-1">John Miller</a>
									<span>miller@mapple.com</span>
								</div>
							</td>
							<td>20 Dec 2024, 5:30 pm</td>
							<td class="text-end">
								<a href="#" class="btn btn-sm btn-light btn-active-light-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									Actions
									<i class="ki-duotone ki-down fs-5 m-0"></i>
								</a>
								<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
									<div class="menu-item px-3">
										<a [routerLink]="['/common','admin-users','user-detail']" class="menu-link px-3">View</a>
									</div>
									<div class="menu-item px-3">
										<a href="#" class="menu-link px-3" data-table-filter="delete_row">Delete</a>
									</div>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</div>

<app-common-add-role-modal (roleAdded)="onRoleAdded()"></app-common-add-role-modal>
<app-common-update-role-modal (roleUpdated)="onRoleUpdated()"></app-common-update-role-modal>

<script src="/assets/js/custom/apps/user-management/roles/list/add.js"></script>
<script src="/assets/js/custom/apps/user-management/roles/list/update-role.js"></script>